<template>
    <div>
        <div>
            <input
                        type="search"
                        @input="debounceFilter"
                        class="form-control text-remove"
                        @keypress="on()"
                        @keyup="offOverlay()"
                        @paste = "onPaste"
                        placeholder="Search project, company, contact, address, phone"
                        style="display: block"
                        id="algolia-search-box"
                        autocomplete="off"
                        contenteditable="true"
                    >

        </div>

        <div id="searchBox" class="hits p-4" style="display: none; left: 5.2%; margin-top: 15px;border-radius: 10px; overflow-y: auto;">
<!--            <div class="card bg-white" id="scrollToTop">-->
                <div class="hitsList" id="loading1" style="display: none;">
                    <div class="row col-xs-12 m-0 d-flex flex-column">
                        <!--Projects-->
                        <div v-if="show.projects" class="mt-3">

                            <div class="d-flex align-items-center mb-3">
                                <div class="d-flex flex-grow-1">
                                    <span class="material-icons text-2xl" style="color: rgb(1 177 175);">folder</span>
                                    <p class="ml-2" style="font-weight: bolder; font-size: 18px">Projects</p>
                                </div>

                                <div class="ml-auto" v-if="projects.length == 5" >
                                    <button id="viewMoreProjects" class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-10 md:px-3 rounded text-followup-nav"
                                    @click="viewMoreProjects();scrollTop()" >View More Projects</button>
                                </div>
                                <div class="ml-auto" v-else-if="projects.length > 5" >
                                    <button class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-10 md:px-3 rounded text-followup-nav"
                                    @click="showLimitedResult();scrollTop()" >Back</button>
                                </div>
                            </div>


                            <div style="border-radius: 15px;border:1px solid #E5E7EB; overflow: hidden;">
                                <table class="searchTable">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Address</th>
                                            <th>Phone</th>
                                            <th>E-mail</th>
                                            <th>Acct.Mngr</th>
                                            <th>Sales Status</th>
                                            <th>Bid Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(project, index) in projects" @click.prevent="link(project, 'project')">
                                            <td v-html="project.custom_project_id ? project.custom_project_id : project.sequential_team_id"></td>
                                            <td v-html="project.name"></td>
                                            <td v-html="project.address || '---'"></td>
                                            <td v-html="project.phone || '---'"></td>
                                            <td v-html="project.email || '---'"></td>
                                            <td v-html="project.account_manager || '---'"></td>
                                            <td v-html="project.sales_status || '---'"></td>
                                            <td v-html="project.base_bid || '---'"></td>
                                        </tr>
                                        <tr v-if="!projects.length"> <td colspan="8" class="text-center">No project found</td></tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>

                </div>

            <div class="hitsList" id="loading" style="display: block;">
                <div class="d-flex align-items-center justify-content-center">
                    <div class="spinner-border mr-2" role="status" aria-hidden="true"></div>
                    <strong>Searching...</strong>
                </div>

            </div>
<!--            </div>-->
        </div>

        <div id="overlay" @click="off()" style="display: none"></div>
    </div>
</template>

<style lang="scss">

.searchTable{
    border-collapse: collapse;
    width: 100%;
    thead {
        background-color: #E5E7EB;
        th {
            border-bottom: 1px solid #E5E7EB;
            padding: 8px;
        }
    }
    tbody {
        tr:hover{
            background-color: #e5e7eb47;
        }
        td {
            border-bottom: 1px solid #E5E7EB;
            padding: 8px;
            cursor: pointer;
        }
    }
}
#searchBox{
    left: 5% !important;
    width: 90%;
    max-height: 71vh;
}

/* Mobile devices (portrait) */ 
@media only screen and (max-width: 767px) { 
    #searchBox{
        left: 0% !important;
        width: 100%;
    }
}

</style>

<style>


.hits {
    position: absolute;
    width: 70vw;
    max-height: 80vh;
    left: 30%;
    overflow-y: scroll;
    padding-bottom: 20px;
    background-color: white;
    border: 0px solid black;
}
@media(max-width:600px){
    .hits{
        left: 0;
        width: auto;
    }

    #hamBurgerBtn{
        display: none;
    }

    #mobileView{
        display: block;
    }
}

@media(min-width:601px){

    #hamBurgerBtn{
        display: none;
    }

    #mobileView{
        display: none;
    }
}

.hitsList {
    list-style-type: none;
    padding: 0;
}
.seeMore {
    text-align: center;
    margin-bottom: 20px;
    margin-top: 10px;
}

/*.seeMoreCompanies {*/
/*    text-align: center;*/
/*    margin-bottom: 20px;*/
/*    width: 80%;*/
/*    margin-left: auto;*/
/*}*/
.seeMoreCompanies{
    margin-left: 30px;
    text-align: center;
    margin-bottom: 20px;
    margin-top: 8px;
}
#overlay {
    position: fixed;
    display: none;
    width: 100%;
    height: 100%;
    top:18px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: -99;
    cursor: pointer;
    margin-top: 56px;
}
</style>

<script>

export default {
    name: "search",
    props: ['appId', "apiKey", "indexName", "isPm", "userId","teamId"],
    data() {
        return {
            searchClient: algoliasearch(
                this.appId,
                this.apiKey,
            ),
            types: {
                'project': 'Job',
                'resource': 'Document',
                'company': 'Company',
                'contact': 'Contact',
            },
            typeOrder:["project", "company", "contact", "resource"],
            showJob: {
                less: true,
                more: false
            },
            showCompany : {
                less: true,
                more: false
            },
            showContact : {
                less: true,
                more: false
            },
            showResource : {
                less: true,
                more: false
            },
            projects:'',
            companies:'',
            company_contacts:'',
            contacts:'',
            resources:'',
            filter:'',
            response:true,
            show: {
                projects: true,
                contacts: false,
                companies: false,
                resources: false,
            },
            limit: 5,
            cancelTokenSource: null

        }
    },

    methods: {
        debounceFilter: _.debounce(function (e) {
            this.filter = e.target.value;
            this.showLimitedResult();
            this.searchData();
        }, 800),

        // elasticSearch(){
        //     document.getElementById("searchBox").style.display = "block";
        //     let params = {'query':'Bulk'};
        //     axios.get(route('api.elastic-search'), {params}).then(({data}) => {
        //         this.projects = data.project
        //         this.companies = data.company
        //         this.company_contacts = data.company_contact
        //         this.contacts = data.contact
        //         this.resources = data.resource
        //         console.log('Projects',this.companies.length > 3)
        //     })
        // },
        searchData() {
            // Cancel the previous request if it exists
            if (this.cancelTokenSource) {
                this.cancelTokenSource.cancel();
            }
            // Create a new cancel token source
            this.cancelTokenSource = axios.CancelToken.source();

            this.response = true;
            let loadingMore = this.limit == 1000;
            const self = this;
            if(!loadingMore){    //loading initial results
                document.getElementById("searchBox").style.display = "block";
                document.getElementById("loading1").style.display = "none";
                document.getElementById("loading").style.display = "block";
            }
            let params = {
                query: self.filter, 
                limit: this.limit,
                get_projects: true,
                isPM: true,
                get_companies: false,
                get_contacts: false,
                get_resources: false,
            };
            if(this.filter){
                axios.get(route('api.elastic-search'), {params,cancelToken: this.cancelTokenSource.token}).then(({data}) => {

                    document.getElementById("loading").style.display = "none";
                    document.getElementById("loading1").style.display = "block";
                    $('#viewMoreProjects, #viewMoreCompanies, #viewMoreContacts').removeClass('inline-loader');

                    this.projects = self.highlightSearchWords(self.filter, data.project);
                    this.companies = self.highlightSearchWords(self.filter, data.company);
                    this.company_contacts = data.company_contact
                    this.resources = self.highlightSearchWords(self.filter, data.resource);
                    this.contacts = self.highlightSearchWords(self.filter, data.contact);
                    this.contacts = data.contact.filter(function(x){
                        return x.name !== null
                    })
                }).catch((error) => {
                    if (axios.isCancel(error)) {
                        // Request was cancelled, ignore the response
                        console.log('Request cancelled');
                    } else {
                        // Handle other errors
                        console.error('Error:', error);
                    }
                });
            }
            else{
                this.projects = []
                this.companies = []
                this.company_contacts = []
                this.contacts = []
                this.resources = []
                document.getElementById("searchBox").style.display = "none";
                document.getElementById("overlay").style.display = "none";
            }
        },
        viewMoreProjects() {
            this.show = {
                projects: true,
                contacts: false,
                companies: false,
                resources: false,
            };
            this.limit = 1000;
            $('#viewMoreProjects').addClass('inline-loader');
            this.searchData();
        },
        viewMoreCompanies() {
            this.show = {
                projects: false,
                contacts: false,
                companies: true,
                resources: false,
            };
            this.limit = 1000;
            setTimeout(() => {
                $('#viewMoreCompanies').addClass('inline-loader');
            }, 100);
            this.searchData();
        },
        viewMoreContacts() {
            this.show = {
                projects: false,
                contacts: true,
                companies: false,
                resources: false,
            };
            this.limit = 1000;
            $('#viewMoreContacts').addClass('inline-loader');
            this.searchData();
        },
        showLimitedResult() {
            this.show = {
                projects: true,
                contacts: false,
                companies: false,
                resources: false,
            };
            this.limit = 5;
            this.projects = this.projects.slice(0, 5);
            this.contacts = this.contacts.slice(0, 5);
            this.companies = this.companies.slice(0, 5);
            this.resources = this.resources.slice(0, 5);
        },
        toggleShowMoreResources(val) {
            if(val){
                this.showJob.less = false
                this.showCompany.less = false
                this.showContact.less = false
                this.showResource.more = true

            }else{
                this.showJob.less = true
                this.showCompany.less = true
                this.showContact.less = true
                this.showResource.more = false
            }
        },
        hitType(type) {
            return this.types[type];
        },
        link(data, type) {
            switch (type) {
                case 'project':
                    if (this.isPm) {
                        window.location = route('project-management.project.edit', {projectManagement: data.id});
                    } else {
                        window.location = route('project.edit', {project: data.id}) + `?project=1`;
                    }
                    break;
                case 'resource':
                    window.open(route('resource-files.show', {resourceFile: data.token}), '_blank');
                    break;
                case 'company':
                    window.location = route('company.show', {company: data.id});
                    break;
                case 'contact':
                    if (data.project_id) {
                        window.location = route('project.edit', {project: data.project_id}) + `?project=1`;
                    }
                    else{
                        window.location = route('contact.edit', {company: data.company_id, contact: data.id});
                    }
                    break;

            }
        },
        iconType(type) {
            switch (type) {
                case 'project':
                    return 'folder';
                    break;
                case 'resource':
                    return 'description';
                    break;
                case 'company':
                    return 'business';
                    break;
                case 'contact':
                    return 'person';
                    break;
                default:
                    return 'folder';
            }
        },
        canSee(item) {
            if (item.type == "project") {
                if (item.users_can_see != null) {

                    if (item.users_can_see.includes(this.userId) && item.team_id == parseInt(this.teamId)) {
                        return true;
                    }
                }
                return false;
            } else if (item.type == "company" || item.type == "contact") {
                if(item.team_id == parseInt(this.teamId)) {
                    return true;
                }
                return false;
            }else{
                return true;
            }
        },
        // transformItems (items){
        //     return items.sort((a, b) => this.typeOrder.indexOf(a.type) - this.typeOrder.indexOf(b.type));
        // },
        on() {
            document.getElementById("overlay").style.display = "block";
            $('#searchBoxHide').show();
        },
        off() {
            document.getElementById("overlay").style.display = "none";
            document.getElementById("searchBox").style.display = "none";
            $('.text-remove').val('');
            $('#searchBoxHide').hide();
            this.showLimitedResult();
        },
        offOverlay(){
            var searchValue = $('#algolia-search-box').val();
            if(searchValue == "" || searchValue == null || searchValue == undefined){
                document.getElementById("overlay").style.display = "none";
                document.getElementById("searchBox").style.display = "none";
                this.showLimitedResult();
            }
        },
        scrollTop(){
            $("#scrollToTop").animate({ scrollTop: 0 }, 600);
            // document.getElementById("scrollToTop").scrollTop = 0; // For Safari
            // document.getElementById("scrollToTop").scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },
        onPaste(evt){
            document.getElementById("overlay").style.display = "block";
            $('#searchBoxHide').show();
        },
        highlightSearchWords(searchWords, searchArray){
            let x = searchArray;
            x.forEach(el =>{
                for (const property in el) {
                    // console.log('searchWords',searchWords)
                    // console.log('el', (el[property] && typeof el[property] === "string" && el[property].toLowerCase().includes(searchWords.toLowerCase())))
                    if(el[property] && typeof el[property] === "string" && el[property].toLowerCase().includes(searchWords.toLowerCase())){
                        // console.log('before', el[property])
                        // el[property] = el[property].toLowerCase().replace(searchWords.toLowerCase(),'<span class="bg-yellow">'+searchWords+'</span>');
                        el[property] = el[property].replace(new RegExp(searchWords, 'gi'), function(match) {
                            return '<span class="bg-yellow">' + match + '</span>';
                        });
                        // console.log('after', el[property])
                    }
                }
            })
            // console.log('xxxxxxx',x)
            return x
        },
    }
}
</script>
